import React from 'react'

import { i18n } from '~/i18n'
import formatCurrency from '~/utils/format-currency'

import { ProductSubtotal, Price } from './order-item-price.styles'

import type { ReactNode } from 'react'

type Props = {
  price: number
  text?: ReactNode
  showNumberForZero?: boolean
  className?: string
}

const OrderItemPrice = ({
  price,
  showNumberForZero,
  text,
  className,
}: Props) => {
  const renderPrice = () => {
    return price <= 0 && !showNumberForZero
      ? i18n.t('components.currency.free')
      : formatCurrency(price)
  }

  return (
    <ProductSubtotal className={className} data-testid="order-item-price">
      {i18n.t('components.order_item_price.total')}
      <Price>{renderPrice()}</Price>
      {text && <div>{text}</div>}
    </ProductSubtotal>
  )
}

export default OrderItemPrice
